import React, { useContext } from 'react';
const MSTContext = React.createContext(null);
// eslint-disable-next-line prefer-destructuring
export const Provider = MSTContext.Provider;
export function useMST(mapStateToProps) {
    const store = useContext(MSTContext);
    if (mapStateToProps) {
        return mapStateToProps(store);
    }
    return store;
}
